import { makeStyles } from "@fluentui/react-components";

export const useHomeStyles = makeStyles({
  loginDiv: {
    backgroundcolor: "#1e64c3 !important",
    paddingLeft: "20px",
    height: "40px",
    width: "280px",
  },
  loginButton: {
    marginRight: "20px",
    backgroundColor: "#0078D4",
    color: "#f7f8fa",
    width: "100%",
  },
  h2: {
    fontsize: "10px",
    fontweight: "75",
    letterspacing: "0",
    color: "#808080",
    paddingLeft: "120px",
  },
  p: {
    fontsize: "5px",
    fontweight: "10",
    letterspacing: "0",
    color: "#808080",
    paddingLeft: "83px",
    textalign: "center",
  },
  loginwrapper: {
    width: "100%",
    height: "calc(100vh - 2px)",
  },
  logincontentwrapper: {
    textalign: "center",
    top: "calc(50vh - 280px)",
    position: "relative",
    width: "100%",
  },
  logo: {
    width: "180px",
    height: "40px",
    textalign: "center",
    paddingLeft: "80px",
  },
  header: {
    width: "auto !Important",
    height: "60px !important",
    backgroundcolor: "transparent !important",
    backgroundposition: "center !important",
    backgroundsize: "contain !important",
    backgroundrepeat: "no-repeat !important",
  },
});
